import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotGamingComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotGaming',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    d: "m22.01 17.178-1.15-7.975c-.13-1.008-.38-2.026-1.03-2.788a3.889 3.889 0 0 0-2.57-1.393 3.771 3.771 0 0 0-2.77.815 4.27 4.27 0 0 0-1.3 1.736h-2.27a4.183 4.183 0 0 0-1.3-1.736 3.797 3.797 0 0 0-2.77-.815c-.99.107-1.9.6-2.57 1.393-.65.772-.89 1.737-1.03 2.788L2.1 17.178c-.08.44-.05.89.09 1.297.15.429.41.804.76 1.072.34.268.75.429 1.18.45.43.022.85-.085 1.22-.31l.02-.011 4.19-2.862c.64-.44 1.39-.676 2.15-.676h.69c.76 0 1.51.236 2.15.676l4.19 2.862.02.01c.37.226.79.333 1.22.311.43-.021.84-.182 1.18-.45.34-.268.61-.643.76-1.072.15-.418.18-.868.09-1.297Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    d: "M7.83 8H6.17v1.17H5v1.66h1.17V12h1.66v-1.17H9V9.17H7.83V8ZM16.988 11.736a1.736 1.736 0 1 0 0-3.472 1.736 1.736 0 0 0 0 3.472Z"
  }));
};
SpotGamingComponent.displayName = 'SpotGaming';
export var SpotGaming = withProvisionalOverrideFromContext(SpotGamingComponent);
//# sourceMappingURL=index.js.map